export type SnackbarColor = "success" | "error" | "info" | "warning";
export interface SnackbarState {
  isVisible: boolean;
  message?: string;
  severity?: SnackbarColor;
}

export interface SnackbarService {
  state: SnackbarState;
  show(message: string, severity?: SnackbarColor): void;
  hide(): void;
}

export const SNACKBAR = Symbol.for("SnackbarService");
